<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.userid" placeholder="用户ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.Name" placeholder="用户名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.email" placeholder="邮箱" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.walletAddress" placeholder="钱包地址" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="list"> 查询 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="UserId" label="用户ID" width="150" />
        <el-table-column prop="Name" label="用户名" />
        <el-table-column prop="Nickname" label="昵称" />
        <el-table-column prop="Email" label="Email" />
        <el-table-column prop="WalletAddress" label="钱包地址" />
        <el-table-column prop="Roles" label="角色" />
        <el-table-column prop="CreatTime" label="上次修改时间">
          <template slot-scope="scope">
            {{ scope.row.CreatTime | formatDate }}
          </template>

        </el-table-column>
        <el-table-column prop="ExpiredTime" label="到期时间">
          <template slot-scope="scope">
            {{ scope.row.ExpiredTime | formatDate }}
          </template>

        </el-table-column>
        <el-table-column prop="Remain" label="post余量" width="150" />
        <el-table-column prop="State" label="状态" width="150" />

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 编辑表单弹窗 -->
      <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑">
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
          <el-form-item label="ID" prop="userId">
            <el-input v-model="editForm.UserId"  readonly/>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="editForm.Name"  readonly/>
          </el-form-item>
          <el-form-item label="昵称" prop="nivkname">
            <el-input v-model="editForm.Nickname"  readonly/>
          </el-form-item>
          <el-form-item label="邮箱地址" prop="email">
            <el-input v-model="editForm.Email"  readonly/>
          </el-form-item>
          <el-form-item label="钱包地址" prop="walletAddress">
            <el-input v-model="editForm.WalletAddress"  readonly/>
          </el-form-item>
          <el-form-item label="Post余量" prop="Level">
            <el-input v-model="editForm.Remain" />
          </el-form-item>
          <el-form-item label="状态" prop="Level">
            <el-input v-model="editForm.State" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button :loading="editLoading" type="primary" @click="editSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import {formatDate} from "../../../../filters";
export default {
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        userid: "",
        name: "",
        email: "",
        walletAddress: "",
      },
      selectedRows: [],
      addForm: {
        id: "",
        name: "",
        Email: "",
        walletAddress: "",
        roles: "",
        Level: "",
        time: "",
      },
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {
        UserId: "",
        Name: "",
        Nickname:"",
        Email: "",
        WalletAddress: "",
        Remain: "",
        State:"",
      },
      editFormVisible: false,
      editLoading: false,
      expireTime : '0',
    };
  },
  computed: {
    formattedExpireTime() {
      return this.expireTime === '0'
        ? 'nil'
        : formatDate(this.expireTime);
    }
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });

      this.axios
        .form("/api/admin/post-user/list", params)
        .then((data) => {
          let totalNum = 0
          if (me.page.total !== null){
            totalNum = me.page.total
          }
          me.results = data.results;
          me.page = data.page;
          if (me.page.total === 0){
            me.page.total = totalNum
          }
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm={
        ...row,
        addTime: 0,  // 初始化时设置默认值
        addMonth: ''  // 清空选择框
      }
      this.expireTime =this.editForm.PermissionExpiredTime
    },
    editSubmit() {
      const params = { ...this.editForm }
      const me = this;
      this.axios
        .form("/api/admin/post-user/update", params)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
          me.$notify.info({ title: "success", message: "操作成功！" })

        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
  }
}
</script>
